//* Import libraries
import { useState, useCallback, useEffect } from "react";

//* Import react-router hooks
import { Link, useNavigate } from "react-router-dom";

//* Import components
import { List } from "../../../component/list/list";
import { Loading } from "../../../component/common/Loading";

//* Import custom hooks
import { useDemands } from "../../../hooks/demand/useDemands";

import { Demands } from "../../../hooks/demand/types/types";
import { Button, Form, Spinner, Row, Col } from "react-bootstrap";
import { Attention } from "../../../component/base/Attention";
import ModalMensagem from "../../../component/base/ModalMensagem";

var debounce = require("lodash.debounce");

export function Correspondecia() {
  const token = localStorage.getItem("token") || "";

  const [answers, setAnswers]: any = useState({});

  const onchangeInput=(e:any,key:any)=>{
    if(e.target.value!='' && Number.isNaN(e.target.value)){
      return;
    }

    let answers_ = { ...answers }
    answers_[key] =e.target.value==''?'': parseInt(e.target.value)
    setAnswers(answers_)
  }





  return (
    <div className="row">
      <div className="col-12">

        <div className={"py-5 px-3"}>
          <div className={"card-body"} id="card">
            <h4
              className="mt-0 header-title"
              style={{ fontSize: "2.0rem", color: "black" }}
            >
              Correspondência entre o software e o mundo real
            </h4>
            <br></br>
            <br></br>
            <h4
              className="mt-0 header-title"
              style={{ fontSize: "1.5rem", color: "black" }}
            >
              Explicação da heurística:
            </h4>
            <br></br>
            <p align="justify"> <strong> Essa heurística determina que o software científico deve apresentar elementos na comunicação, principalmente ícones, textos e cores, que sejam familiares 
              aos usuários e que tenham significado para a área do domínio da aplicação. Além disso, o software deve buscar seguir uma ordem lógica na execução das tarefas que os 
              usuários já estão acostumados e estão sendo abstraídas para o software. Assim, tarefas realizadas em outros softwares ou tarefas realizadas de forma não digital, devem 
              ser respeitadas de modo a modificar o mínimo possível o fluxo de execução que o usuário está acostumado. Exemplo: Durante a construção da interface, o desenvolvedor 
              pode usar, quando necessário, termos que sejam específicos da área e que tragam significado para a ação que será realizada. Assim, em um software científico voltado 
              para a comparação de cadeias de DNA, por exemplo, os desenvolvedores podem usar o termo ’concatenar strings’ (ZAFALON et al., 2018) por ser um termo familiar para os 
              usuários de software desse domínio. </strong> </p>
            <p align="justify"> <strong> A heurística Correspondência entre o software e o mundo real foi subdivida em dois critérios de análise, a saber: Significado dos elementos de comunicação 
              (C1) e Abstração e ordem do fluxo de execução C2. </strong> </p>
            <br></br>
              <h4
              className="mt-0 header-title"
              style={{ fontSize: "1.5rem", color: "black" }}
            >
              Perguntas para avaliação:
            </h4>
            <br></br>


            <Form.Group className="mb-3">
              <Form.Label style={{fontSize:18}} align="justify">
              P1.C1) Os ícones utilizados no software estão relacionados com o domínio da área de aplicação, são familiares para os pesquisadores e representam corretamente a 
              função associada? Indique o número de ícones analisados (N) e a quantidade de ícones coerentes encontrados (Q). Exemplo de comunicação: ícone de play indicando que 
              ao ser clicado o software irá iniciar uma análise ou um processamento de dados. <Attention />
              </Form.Label>
              <div>
                <div className="d-flex align-items-center mb-2">

                <span style={{ fontSize: '1.2rem' }}>Número de ícones analisados: &nbsp;</span>
                  <Form.Control
                    placeholder=""
                    style={{ width: 42, padding: 0, marginRight: 10, textAlign: 'center' }}
                    value={answers['1_1'] ?? ''}
                    onChange={(e) => {

                      onchangeInput(e,'1_1')
                    }}
                    required
                    
                  />
                  
                </div>

                <div className="d-flex align-items-center mb-2">

                <span style={{ fontSize: '1.2rem' }}>Quantidade de ícones coerentes: &nbsp;</span>
                  <Form.Control
                    placeholder=""
                    style={{ width: 42, padding: 0, marginRight: 10, textAlign: 'center' }}
                    value={answers['1_2'] ?? ''}
                    onChange={(e) => {

                      onchangeInput(e,'1_2')
                    }}
                    required
                    
                  />
                  
                </div>
              </div>
            </Form.Group>


            <br></br>
            <Form.Group className="mb-3">
              <Form.Label style={{fontSize:18}} align="justify">
              P2.C1)   Os textos utilizados no software são familiares para os pesquisadores e consideram a terminologia da área do domínio da aplicação? Indique o número de textos 
              analisados (N) e a quantidade de textos coerentes encontrados (Q). Exemplo de comunicação: A palavra ciclo pode apresentar dois significados, sendo que pode representar 
              algo que vai do início ao final de uma tarefa e encerra ou algo que vai do início ao final e volta para o início se repetindo N vezes. <Attention />
              </Form.Label>
              <div>
                <div className="d-flex align-items-center mb-2">

                <span style={{ fontSize: '1.2rem' }}>Número de textos analisados: &nbsp;</span>
                  <Form.Control
                    placeholder=""
                    style={{ width: 42, padding: 0, marginRight: 10, textAlign: 'center' }}
                    value={answers['2_1'] ?? ''}
                    onChange={(e) => {

                      onchangeInput(e,'2_1')
                    }}
                    required
                    
                  />
                  
                </div>

                <div className="d-flex align-items-center mb-2">

                <span style={{ fontSize: '1.2rem' }}>Quantidade de textos coerente: &nbsp;</span>
                  <Form.Control
                    placeholder=""
                    style={{ width: 42, padding: 0, marginRight: 10, textAlign: 'center' }}
                    value={answers['2_2'] ?? ''}
                    onChange={(e) => {

                      onchangeInput(e,'2_2')
                    }}
                    required
                    
                  />
                  
                </div>
              </div>
            </Form.Group>
            <br></br>
            <Form.Group className="mb-3">
              <Form.Label style={{fontSize:18}} align="justify">
              P3.C1)   As cores utilizadas nas comunicações, principalmente de resultados, consideram os significados associados à área do domínio da aplicação? Indique 
              o número de comunicações analisadas (N) e a quantidade de cores coerentes encontradas (Q). Exemplo de comunicação: Em um software de análise populacional 
              apresentar em cores quentes (vermelha) as regiões com maior concentração e cores frias (azul) regiões com menor concentração. <Attention />
              </Form.Label>
              <div>
                <div className="d-flex align-items-center mb-2">

                <span style={{ fontSize: '1.2rem' }}>Número de comunicações analisadas: &nbsp;</span>
                  <Form.Control
                    placeholder=""
                    style={{ width: 42, padding: 0, marginRight: 10, textAlign: 'center' }}
                    value={answers['3_1'] ?? ''}
                    onChange={(e) => {

                      onchangeInput(e,'3_1')
                    }}
                    required
                    
                  />
                  
                </div>

                <div className="d-flex align-items-center mb-2">

                <span style={{ fontSize: '1.2rem' }}>Quantidade de cores coerentes: &nbsp;</span>
                  <Form.Control
                    placeholder=""
                    style={{ width: 42, padding: 0, marginRight: 10, textAlign: 'center' }}
                    value={answers['3_2'] ?? ''}
                    onChange={(e) => {

                      onchangeInput(e,'3_2')
                    }}
                    required
                    
                  />
                  
                </div>
              </div>
            </Form.Group>
            <br></br>
            <Form.Group className="mb-3">
              <Form.Label style={{fontSize:18}} align="justify">
              P1.C2)   As funções do software que são abstrações de tarefas realizadas em outros softwares seguem a mesma ordem de execução, na qual os pesquisadores já 
              estão familiarizados? Alguma função foi modificada de forma proposital? Indique o número de funções analisadas (N), a quantidade de respostas positivas (Q) e a 
              quantidade de modificações propositais (Qp). <Attention />
              </Form.Label>
              <div>
                <div className="d-flex align-items-center mb-2">

                <span style={{ fontSize: '1.2rem' }}>Número de funções analisadas: &nbsp;</span>
                  <Form.Control
                    placeholder=""
                    style={{ width: 42, padding: 0, marginRight: 10, textAlign: 'center' }}
                    value={answers['4_1'] ?? ''}
                    onChange={(e) => {

                      onchangeInput(e,'4_1')
                    }}
                    required
                    
                  />
                  
                </div>

                <div className="d-flex align-items-center mb-2">

                <span style={{ fontSize: '1.2rem' }}>Quantidade de respostas positivas: &nbsp;</span>
                  <Form.Control
                    placeholder=""
                    style={{ width: 42, padding: 0, marginRight: 10, textAlign: 'center' }}
                    value={answers['4_2'] ?? ''}
                    onChange={(e) => {

                      onchangeInput(e,'4_2')
                    }}
                    required
                    
                  />
                  
                </div>

                <div className="d-flex align-items-center mb-2">

                <span style={{ fontSize: '1.2rem' }}>Quantidade de respostas positivas: &nbsp;</span>
                  <Form.Control
                    placeholder=""
                    style={{ width: 42, padding: 0, marginRight: 10, textAlign: 'center' }}
                    value={answers['4_3'] ?? ''}
                    onChange={(e) => {

                      onchangeInput(e,'4_3')
                    }}
                    required
                    
                  />
                  
                </div>
              </div>
            </Form.Group>
            <br></br>
            <Form.Group className="mb-3">
              <Form.Label style={{fontSize:18}} align="justify">
              P1-1.C2)   As funções do software que foram modificadas de forma proposital apresentam alguma explicação ou documentação que destaque os motivos da mudança e como a 
              função deve ser executada? Indique o número de funções que apresentam explicação ou documentação da mudança (Nf). <Attention />
              </Form.Label>
              <div>
                <div className="d-flex align-items-center mb-2">

                <span style={{ fontSize: '1.2rem' }}>Número de funções que apresentam explicação ou documentação da mudança: &nbsp;</span>
                  <Form.Control
                    placeholder=""
                    style={{ width: 42, padding: 0, marginRight: 10, textAlign: 'center' }}
                    value={answers['4_1'] ?? ''}
                    onChange={(e) => {

                      onchangeInput(e,'4_1')
                    }}
                    required
                    
                  />
                  
                </div>

               
              </div>
            </Form.Group>
            <br></br>
            <Form.Group className="mb-3">
              <Form.Label style={{fontSize:18}} align="justify">
              P2.C2)   As funções do software que são abstrações de tarefas não digitais, ou seja, realizadas de forma manual e sem o uso de dispositivos eletrônicos, apresentam 
              alguma explicação ou documentação que indique como a função deve ser executada e como a abstração foi realizada? Indique o número de funções que são abstrações de 
              tarefas não digitais (N) e a quantidade dessas funções que apresentam explicação ou documentação (Q). <Attention />
              </Form.Label>
              <div>
                <div className="d-flex align-items-center mb-2">

                <span style={{ fontSize: '1.2rem' }}>Número de funções que são abstrações de tarefas não digitais: &nbsp;</span>
                  <Form.Control
                    placeholder=""
                    style={{ width: 42, padding: 0, marginRight: 10, textAlign: 'center' }}
                    value={answers['5_1'] ?? ''}
                    onChange={(e) => {

                      onchangeInput(e,'5_1')
                    }}
                    required
                    
                  />
                  
                </div>

                <div className="d-flex align-items-center mb-2">

                <span style={{ fontSize: '1.2rem' }}>Quantidade dessas funções que apresentam explicação ou documentação: &nbsp;</span>
                  <Form.Control
                    placeholder=""
                    style={{ width: 42, padding: 0, marginRight: 10, textAlign: 'center' }}
                    value={answers['5_2'] ?? ''}
                    onChange={(e) => {

                      onchangeInput(e,'5_2')
                    }}
                    required
                    
                  />
                  
                </div>
              </div>
            </Form.Group>
            <br></br>

            <button onClick={(e)=>{

            }} className="btn btn-success btn-lg w-100">
                          Gerar resultado
                        </button>

            <ModalMensagem/>
           












          </div>
        </div>
      </div>

    </div>
  );
}
